export default __webpack_public_path__ + "static/media/govHK_logo.a90a041b.png";